{
  "familyId": "SPR-ACCENT",
  "questions": [
    {
      "id": "SPR-ACCENT-001",
      "familyId": "SPR-ACCENT",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leestekens",
      "subSkill": "accent_klemtoon",
      "questionType": "multiple_choice",
      "question": "Welk woord is correct gespeld?",
      "context": "Na het sollicitatiegesprek stuurde ze haar ... op.",
      "options": ["résumé", "resume", "resumé", "résume"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Accent aigu op Franse leenwoorden",
            "content": "Het woord 'résumé' komt uit het Frans en heeft twee accenten aigu (é). Beide e's worden beklemtoond uitgesproken: ré-su-mé. Zonder accenten zou je het als 'rezuumuh' lezen. Onthoud: Franse leenwoorden met een beklemtoonde 'e' behouden hun accent aigu.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "accent_aigu_double",
      "variantIndex": 1,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "'Résumé' is een Frans leenwoord met twee accenten aigu. Regel: Franse leenwoorden met een beklemtoonde 'e' behouden hun accent aigu (é). De eerste é geeft de klemtoon op de eerste lettergreep aan (ré-), de tweede é op de laatste (-mé). Zonder accenten verandert de uitspraak volledig. Vergelijk: 'resume' (zonder accenten) zou je als 'rezuumuh' lezen — dat klopt niet.",
        "solutionSteps": [
          "Herken: 'résumé' is een Frans leenwoord",
          "Tel de beklemtoonde e's: twee (ré- en -mé)",
          "Beide e's krijgen een accent aigu (é)",
          "Dus: résumé (met twee accenten aigu)"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Résumé' heeft twee accenten aigu: op de eerste én de laatste e. Beide klinken als 'ee'.",
          "1": "Je dacht waarschijnlijk dat accenten niet nodig zijn. Maar zonder accenten verandert de uitspraak: 'resume' zou je als 'rezuumuh' lezen. Onthoud: Franse leenwoorden met een beklemtoonde 'e' behouden hun accent aigu.",
          "2": "Je dacht waarschijnlijk dat alleen de laatste e een accent krijgt. Maar ook de eerste e is beklemtoond: ré-su-mé. Beide e's klinken als 'ee', dus beide krijgen een accent aigu. Onthoud: luister naar de uitspraak — elke beklemtoonde 'e' krijgt een accent.",
          "3": "Je dacht waarschijnlijk dat alleen de eerste e een accent krijgt. Maar ook de laatste e is beklemtoond: ré-su-mé. Onthoud: luister naar de uitspraak — elke 'ee'-klank in een Frans leenwoord krijgt een accent aigu."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.accent-forgotten", "label": "Beide accenten vergeten", "optionIndex": 1 },
          { "id": "spr.accent-partial", "label": "Alleen laatste accent geplaatst", "optionIndex": 2 },
          { "id": "spr.accent-partial", "label": "Alleen eerste accent geplaatst", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-ACCENT-002",
      "familyId": "SPR-ACCENT",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leestekens",
      "subSkill": "accent_klemtoon",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct gespeld?",
      "options": [
        "Er is maar éen manier om dit op te lossen.",
        "Er is maar eén manier om dit op te lossen.",
        "Er is maar één manier om dit op te lossen.",
        "Er is maar een manier om dit op te lossen."
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Één vs. een — wanneer accenten?",
            "content": "'Één' (met twee accenten) = het telwoord (= 1). 'Een' (zonder accent) = het lidwoord (= een bepaald). Vergelijk: 'Ik heb één kat' (= precies 1) vs. 'Ik heb een kat' (= een bepaalde kat). Let op: beide e's krijgen een accent: één, niet éen of eén.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "accent_een_telwoord",
      "variantIndex": 2,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "In deze zin bedoelen we 'precies 1 manier' — het is een telwoord. Het telwoord 'één' schrijf je met twee accenten aigu om het te onderscheiden van het lidwoord 'een'. Vergelijk: 'Er is maar één manier' (= precies 1) vs. 'Er is een manier' (= er bestaat een manier). Let op: beide e's krijgen een accent: één. Niet 'éen' (alleen de eerste) of 'eén' (alleen de tweede).",
        "solutionSteps": [
          "Bepaal de betekenis: 'precies 1' of 'een bepaald'?",
          "Hier: 'maar één' = nadruk op het getal → telwoord",
          "Telwoord 'één' krijgt twee accenten aigu",
          "Check: één (beide e's accent), niet éen of eén"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat alleen de eerste e een accent krijgt: 'éen'. Maar bij het telwoord 'één' krijgen beide e's een accent aigu. Onthoud: één (twee accenten), niet éen.",
          "1": "Je dacht waarschijnlijk dat alleen de tweede e een accent krijgt: 'eén'. Maar bij het telwoord 'één' krijgen beide e's een accent aigu. Onthoud: één (twee accenten), niet eén.",
          "2": "Goed! 'Één' is het telwoord (= precies 1). Beide e's krijgen een accent aigu.",
          "3": "Je dacht waarschijnlijk dat 'een' zonder accenten ook kan. Maar hier staat 'maar één' — dat benadrukt het getal. Zonder accenten is 'een' het lidwoord ('een manier' = er bestaat een manier). Onthoud: bij nadruk op het getal → één."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.accent-partial", "label": "Alleen eerste e accent (éen)", "optionIndex": 0 },
          { "id": "spr.accent-partial", "label": "Alleen tweede e accent (eén)", "optionIndex": 1 },
          { "id": "spr.accent-forgotten", "label": "Geen accent (een als lidwoord)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-ACCENT-003",
      "familyId": "SPR-ACCENT",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leestekens",
      "subSkill": "accent_klemtoon",
      "questionType": "fill_in",
      "question": "Vul het woord correct in met het juiste accent: 'De bakker verkoopt heerlijke ... brûlée.'",
      "data": {
        "acceptedAnswers": ["crème", "creme"],
        "placeholder": "..."
      },
      "correctAnswer": "crème",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Accent grave (è) in het Nederlands",
            "content": "Het accent grave (è) geeft een open 'e'-klank aan. 'Crème' heeft een accent grave: de e klinkt als 'eh' (open). Vergelijk met accent aigu (é): die klinkt als 'ee' (gesloten). Crème brûlée heeft beide: è (open) en é (gesloten).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "accent_grave_creme",
      "variantIndex": 3,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "'Crème' heeft een accent grave (è) op de e. Dit accent geeft aan dat de e open klinkt: als 'eh'. Vergelijk met het accent aigu (é) dat een gesloten 'ee'-klank aangeeft. In 'crème brûlée' zie je beide accenten: crème (è = open 'eh') en brûlée (é = gesloten 'ee'). Het accent grave komt minder vaak voor in het Nederlands dan het accent aigu, maar is belangrijk bij woorden als crème, scène en carrière.",
        "solutionSteps": [
          "Herken: 'crème' is een Frans leenwoord",
          "De e klinkt open ('eh'), niet gesloten ('ee')",
          "Een open e-klank krijgt een accent grave (è)",
          "Dus: crème (met accent grave)"
        ],
        "distractorExplanations": {}
      }
    },
    {
      "id": "SPR-ACCENT-004",
      "familyId": "SPR-ACCENT",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leestekens",
      "subSkill": "accent_klemtoon",
      "questionType": "multiple_choice",
      "question": "Welk woord is correct gespeld?",
      "context": "De school hield een ... onder de ouders over het schoolreisje.",
      "options": ["enquete", "enquête", "enquëte", "énquête"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Accent circumflex (ê) in het Nederlands",
            "content": "Het accent circumflex (ê) — het 'dakje' — komt voor in enkele Franse leenwoorden. 'Enquête' heeft een accent circumflex op de tweede e. Dit geeft de uitspraak 'eh' aan (vergelijkbaar met accent grave). Andere voorbeelden: crêpe, fête.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "accent_circumflex",
      "variantIndex": 4,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "'Enquête' is een Frans leenwoord met een accent circumflex (ê) — het 'dakje'. Regel: sommige Franse leenwoorden hebben een accent circumflex dat de uitspraak aangeeft. De ê klinkt als 'eh' (open klank). Het woord wordt uitgesproken als 'on-keh-tuh'. Zonder het dakje zou je 'enquete' anders lezen. Het accent circumflex komt in het Nederlands alleen voor bij Franse leenwoorden, zoals ook crêpe en fête. Let op het verschil: trema (¨) = klinkers apart uitspreken, circumflex (^) = speciale klank in Frans leenwoord.",
        "solutionSteps": [
          "Herken: 'enquête' is een Frans leenwoord",
          "De tweede e klinkt als 'eh' (open klank)",
          "In dit woord staat een accent circumflex (ê): het 'dakje'",
          "Dus: enquête (met accent circumflex op de tweede e)"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat het accent niet nodig is. Maar zonder accent verandert de uitspraak: 'enquete' zou je anders lezen. Onthoud: Franse leenwoorden met een bijzondere e-klank behouden hun accent.",
          "1": "Goed! 'Enquête' heeft een accent circumflex (ê) op de tweede e. Dit is het 'dakje' dat de uitspraak aangeeft.",
          "2": "Je dacht waarschijnlijk dat er een trema (ë) op moet. Maar een trema gebruik je om aan te geven dat twee klinkers apart worden uitgesproken (zoals in 'geëist'). Hier heb je een accent circumflex (ê) nodig: enquête. Onthoud: trema (¨) ≠ circumflex (^).",
          "3": "Je dacht waarschijnlijk dat de eerste e ook een accent krijgt. Maar in 'enquête' is alleen de tweede e bijzonder: die klinkt als 'eh'. De eerste e is een gewone, onbeklemtoonde e. Onthoud: alleen de e die anders klinkt krijgt een accent."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.accent-forgotten", "label": "Accent vergeten", "optionIndex": 0 },
          { "id": "spr.accent-type-confused", "label": "Trema i.p.v. circumflex", "optionIndex": 2 },
          { "id": "spr.accent-partial", "label": "Accent op verkeerde positie", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-ACCENT-005",
      "familyId": "SPR-ACCENT",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leestekens",
      "subSkill": "accent_klemtoon",
      "questionType": "multiple_choice",
      "question": "In welke zin is het accent correct gebruikt?",
      "options": [
        "Heb je voor óf na de pauze gegeten?",
        "Heb je voor of ná de pauze gegeten?",
        "Heb je vòòr of na de pauze gegeten?",
        "Heb je vóór of na de pauze gegeten?"
      ],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Accent op 'vóór' — klemtoon voor onderscheid",
            "content": "'Vóór' (met accent) = het voorzetsel van tijd/plaats: 'vóór de pauze' (= eerder dan). 'Voor' (zonder accent) = ten behoeve van: 'ik doe het voor jou'. Het accent voorkomt verwarring. Vergelijk ook: 'één' vs. 'een', 'vóórkomen' vs. 'voorkómen'.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "accent_voor_onderscheid",
      "variantIndex": 5,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "In deze zin betekent 'vóór' het voorzetsel van tijd: eerder dan de pauze. Het accent aigu op 'vóór' onderscheidt het van 'voor' (= ten behoeve van). Dit is een belangrijk verschil: 'Ik sta vóór je' (= voor je in de rij) vs. 'Ik doe het voor je' (= ten behoeve van jou). Het accent valt op 'vóór' omdat daar de nadruk ligt in het contrast 'vóór of na'. De andere woorden ('of', 'na') hebben geen accent nodig.",
        "solutionSteps": [
          "Bepaal de betekenis: 'eerder dan' of 'ten behoeve van'?",
          "Hier: 'vóór of na' = tijdsaanduiding → accent nodig",
          "Het accent aigu valt op 'vóór' (niet op 'of' of 'na')",
          "Check: vóór (met accent) = eerder dan ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 'óf' een accent krijgt. Maar 'of' is een voegwoord dat geen accent nodig heeft. Het accent hoort op 'vóór' om het te onderscheiden van 'voor' (= ten behoeve van). Onthoud: het accent valt op het woord met twee betekenissen.",
          "1": "Je dacht waarschijnlijk dat 'ná' een accent krijgt. Maar 'na' heeft maar één betekenis en hoeft niet onderscheiden te worden. Het accent hoort op 'vóór' omdat dat woord twee betekenissen heeft. Onthoud: accenten gebruik je om verwarring te voorkomen.",
          "2": "Je dacht waarschijnlijk dat 'vóór' een accent grave (`) krijgt: 'vòòr'. Maar in het Nederlands gebruiken we het accent aigu (´) voor klemtoon: vóór. Het accent grave (`) komt alleen voor bij woorden als 'crème' en 'scène'. Onthoud: klemtoon-accent = aigu (´).",
          "3": "Goed! 'Vóór' krijgt een accent aigu omdat het hier 'eerder dan' betekent, ter onderscheiding van 'voor' (= ten behoeve van)."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.accent-forgotten", "label": "Accent op verkeerd woord (óf)", "optionIndex": 0 },
          { "id": "spr.accent-forgotten", "label": "Accent op verkeerd woord (ná)", "optionIndex": 1 },
          { "id": "spr.accent-type-confused", "label": "Accent grave i.p.v. aigu", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-ACCENT-006",
      "familyId": "SPR-ACCENT",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leestekens",
      "subSkill": "accent_klemtoon",
      "questionType": "matching",
      "question": "Koppel elk woord aan het juiste type accent.",
      "data": {
        "pairs": [
          { "left": "café, résumé", "right": "accent aigu (é)" },
          { "left": "crème, scène", "right": "accent grave (è)" },
          { "left": "enquête, crêpe", "right": "accent circumflex (ê)" },
          { "left": "geëist, coöperatie", "right": "trema (¨)" }
        ],
        "correctMatches": { "0": "0", "1": "1", "2": "2", "3": "3" }
      },
      "correctAnswer": { "0": "0", "1": "1", "2": "2", "3": "3" },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vier soorten accenten in het Nederlands",
            "content": "1. Accent aigu (é): beklemtoonde, gesloten e ('ee'-klank) → café, résumé. 2. Accent grave (è): open e ('eh'-klank) → crème, scène. 3. Accent circumflex (ê): 'dakje', ook open e → enquête, crêpe. 4. Trema (¨): geeft aan dat klinkers apart worden uitgesproken → ge-ëist (niet 'geist'), co-öperatie (niet 'kooperatie').",
            "icon": "book"
          }
        }
      ],
      "conceptId": "accent_types_overview",
      "variantIndex": 6,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.67,
      "feedback": {
        "explanationText": "In het Nederlands gebruiken we vier soorten accenten: 1) Het accent aigu (é) voor een beklemtoonde, gesloten 'ee'-klank: café, résumé. 2) Het accent grave (è) voor een open 'eh'-klank: crème, scène. 3) Het accent circumflex (ê) — het 'dakje' — ook voor een open klank in Franse leenwoorden: enquête, crêpe. 4) Het trema (¨) om aan te geven dat twee klinkers apart worden uitgesproken: ge-ëist (niet 'geist'), co-öperatie (niet 'kooperatie'). Let op: het trema is technisch geen accent, maar een leesteken.",
        "solutionSteps": [
          "Accent aigu (é) = gesloten 'ee'-klank → café, résumé",
          "Accent grave (è) = open 'eh'-klank → crème, scène",
          "Accent circumflex (ê) = 'dakje', open klank → enquête, crêpe",
          "Trema (¨) = klinkers apart uitspreken → geëist, coöperatie"
        ],
        "distractorExplanations": {}
      }
    },
    {
      "id": "SPR-ACCENT-007",
      "familyId": "SPR-ACCENT",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leestekens",
      "subSkill": "accent_klemtoon",
      "questionType": "error_spotting",
      "question": "Zoek de spelfout in deze tekst en verbeter het woord.",
      "data": {
        "text": "Na het sollicitatiegesprek stuurde ze haar resume op. De manager was onder de indruk van haar ervaring.",
        "errors": [
          {
            "word": "resume",
            "position": 8,
            "correction": "résumé",
            "explanation": "'Resume' mist beide accenten aigu. Het Franse leenwoord 'résumé' heeft twee accenten: op de eerste én de laatste e. Zonder accenten verandert de uitspraak."
          }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Accenten op Franse leenwoorden", "content": "Franse leenwoorden met een beklemtoonde 'e' behouden hun accent aigu (é). 'Résumé' heeft twee accenten: ré-su-mé. Zonder accenten verandert de uitspraak volledig.", "icon": "book" } }],
      "conceptId": "accent_error_spotting",
      "variantIndex": 7,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "'Resume' mist beide accenten aigu. Het moet 'résumé' zijn — een Frans leenwoord met twee beklemtoonde e's. Regel: Franse leenwoorden met een beklemtoonde 'e' behouden hun accent aigu (é). De eerste é geeft de klemtoon op ré- aan, de tweede op -mé. 'Manager' en 'sollicitatiegesprek' zijn correct — 'manager' is een Engels leenwoord (geen accent nodig), 'sollicitatiegesprek' is een Nederlands woord.",
        "solutionSteps": [
          "Lees de tekst en zoek woorden die een accent nodig hebben",
          "'Resume' is een Frans leenwoord → heeft accenten nodig",
          "Beide e's zijn beklemtoond: ré-su-mé",
          "Correctie: resume → résumé (twee accenten aigu)"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "SPR-ACCENT-008",
      "familyId": "SPR-ACCENT",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leestekens",
      "subSkill": "accent_klemtoon",
      "questionType": "true_false_series",
      "question": "Beoordeel of elk woord correct gespeld is (let op de accenten).",
      "data": {
        "statements": [
          { "text": "'Café' is correct gespeld.", "isTrue": true },
          { "text": "'Creme' is correct gespeld.", "isTrue": false },
          { "text": "'Enquête' is correct gespeld.", "isTrue": true },
          { "text": "'Resumé' is correct gespeld.", "isTrue": false },
          { "text": "'Één' is correct gespeld.", "isTrue": true }
        ]
      },
      "correctAnswer": [true, false, true, false, true],
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Accenten controleren", "content": "Café (é = gesloten ee-klank) ✓. Creme mist accent grave → crème (è = open eh-klank). Enquête (ê = circumflex) ✓. Resumé mist het eerste accent → résumé (twee accenten). Één (telwoord met twee accenten) ✓.", "icon": "book" } }],
      "conceptId": "accent_tf_series",
      "variantIndex": 8,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Controleer elk woord op het juiste accent. 'Café' ✓ (accent aigu op de é). 'Creme' ✗ mist het accent grave → moet 'crème' zijn (è = open 'eh'-klank). 'Enquête' ✓ (accent circumflex op de ê). 'Resumé' ✗ mist het eerste accent → moet 'résumé' zijn (twee accenten aigu: ré- en -mé). 'Één' ✓ (telwoord met twee accenten aigu). Strategie: spreek het woord uit en luister naar de beklemtoonde klinkers — elke bijzondere klank heeft een accent nodig.",
        "solutionSteps": [
          "Café: é = gesloten ee-klank → correct ✓",
          "Creme: mist accent grave → crème (è = open eh-klank)",
          "Enquête: ê = circumflex → correct ✓",
          "Resumé: mist eerste accent → résumé (twee accenten)",
          "Één: telwoord met twee accenten → correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}